module.exports = __webpack_public_path__ + "static/img/kawachi_02.51039de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_02.jpg
// module id = EzNT
// module chunks = 0